import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams,
    useFetcher
} from "react-router-dom"
import { GlobalContext } from '../GlobalContext'

import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import ChecklistCategoryNames from './ChecklistCategoryNames'

type Props = {
    checklistData: ObjectStringKeyAnyValue
}


function SummaryChecklistCategories({
    checklistData
}: Props) {

    const {
        tableData
    } = useContext(GlobalContext)



    return <div className={`bg-gray-300 flex flex-row w-full gap-4 justify-between items-center rounded px-2 py-1 text-sm`}>
        <div className={`flex flex-row gap-2 justify-start items-start`}>
            <p className={`font-bold`}>Checklist categories:</p>

            <ChecklistCategoryNames
                checklistData={checklistData}
                showIfNone={true}
            />

        </div>
    </div>
}
export default SummaryChecklistCategories